<template>
  <v-container>
    <transition name="fade">
      <v-alert v-if="api.isError" dense border="left" type="warning">
        {{ api.error }}
      </v-alert>
    </transition>
    <div class="text-h5 pa-3"> {{ $t("view.PageMainPlayerMathPerformance.title") }}</div>
    <v-row>
      <v-col>
        <SchoolYear
          ref="dropdown_school_year"
          :callbackSelect="selectSyllabus"
          :callbackError="showError"
        ></SchoolYear>
      </v-col>
      <v-col>
        <DropdownChapter
          ref="dropdown_chapter"
          :syllabus="syllabus"
          :callbackSelect="selectChapter"
          :callbackError="showError"
        ></DropdownChapter>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
   <div v-if="!playerData && !isLoading" class="text-center mt-8">
  <v-card flat class="mx-auto" style="max-width: 400px;">
    <v-card-text class="pa-8">
      <v-icon size="64" color="grey lighten-1" class="mb-4">
        mdi-account-search
      </v-icon>
      <div class="text-h6 mb-2 text--secondary">
        {{ $t("string.player_not_found") }} 
      </div>
      <div class="text-body-2 text--secondary mb-4">
       <div class="text-h5 pa-3"> {{ $t("view.PageMainPlayerMathPerformance.player_not_found_mgs") }}</div>
      </div>
    </v-card-text>
  </v-card>
</div>
    <div v-if="chapter && !isLoading && playerData">
      <div class="text-caption mb-1">
        {{ $t("model.name.chapter") }} {{ chapter.sort }}
      </div>
      <div class="text-h5 mb-3">{{ chapter.name }}</div>
      <div style="max-width: 800px" class="mx-auto">
        <div v-if="topics.length > 0">
          <v-card
            v-for="(item, i) in topics"
            :key="i + 'all'"
            class="mb-3"
            flat
            outlined
          >
            <!-- Mobile Layout -->
            <div class="d-block d-sm-none pa-3">
              <v-row align="center" no-gutters>
                <v-col cols="2">
                  <v-avatar size="32" color="primary">
                    <span class="white--text font-weight-bold">{{
                      i + 1
                    }}</span>
                  </v-avatar>
                </v-col>
                <v-col cols="10" class="pl-3">
                  <div class="font-weight-medium text-body-1">
                    {{ item.name }}
                  </div>
                </v-col>
              </v-row>

              <v-row class="mt-3" align="center" no-gutters>
                <v-col cols="4" class="text-center">
                  <div class="text-caption text--secondary mb-1">{{ $t("model.prop.grade") }}</div>
                  <v-img
                    contain
                    max-width="35"
                    class="mx-auto"
                    :src="
                      require(item.playerData
                        ? item.playerData.grade == 'A'
                          ? '@/assets/math/shields/gradeA.png'
                          : item.playerData.grade == 'B'
                          ? '@/assets/math/shields/gradeB.png'
                          : item.playerData.grade == 'C'
                          ? '@/assets/math/shields/gradeC.png'
                          : '@/assets/math/shields/gradeF.png'
                        : '@/assets/math/shields/gradeX.png')
                    "
                  ></v-img>
                </v-col>

                <v-col cols="4" class="text-center">
                  <div class="text-caption text--secondary mb-1"> {{ $t("model.prop.stars") }}</div>
                  <v-rating
                    :value="item.playerData ? item.playerData.topStar : 0"
                    background-color="amber"
                    color="amber"
                    length="3"
                    readonly
                    dense
                    size="18"
                  ></v-rating>
                </v-col>

                <v-col cols="4" class="text-center">
                  <div class="text-caption text--secondary mb-1">
                   {{ $t("model.prop.lastUpdated") }}
                  </div>
                  <div class="text-body-2">
                    <span
                      v-if="item.playerData && item.playerData.timestampUpdated"
                    >
                      {{
                        $moment(item.playerData.timestampUpdated).format(
                          "DD/MM/YY"
                        )
                      }}
                    </span>
                    <span v-else class="text--disabled">-</span>
                  </div>
                  <div
                    class="text-caption text--secondary"
                    v-if="item.playerData && item.playerData.timestampUpdated"
                  >
                    {{
                      $moment(item.playerData.timestampUpdated).format("HH:mm")
                    }}
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Desktop/Tablet Layout -->
            <div class="d-none d-sm-block pa-3">
              <v-row align="center" no-gutters>
                <!-- Topic Number and Name -->
                <v-col cols="6" md="6">
                  <div class="d-flex align-center">
                    <v-avatar size="32" color="primary" class="mr-3">
                      <span class="white--text font-weight-bold">{{
                        i + 1
                      }}</span>
                    </v-avatar>
                    <div class="font-weight-medium text-body-1">
                      {{ item.name }}
                    </div>
                  </div>
                </v-col>

                <!-- Grade Shield -->
                <v-col cols="2" md="2" class="text-center">
                  <v-img
                    contain
                    max-width="40"
                    class="mx-auto"
                    :src="
                      require(item.playerData
                        ? item.playerData.grade == 'A'
                          ? '@/assets/math/shields/gradeA.png'
                          : item.playerData.grade == 'B'
                          ? '@/assets/math/shields/gradeB.png'
                          : item.playerData.grade == 'C'
                          ? '@/assets/math/shields/gradeC.png'
                          : '@/assets/math/shields/gradeF.png'
                        : '@/assets/math/shields/gradeX.png')
                    "
                  ></v-img>
                </v-col>

                <!-- Star Rating -->
                <v-col cols="2" md="2" class="text-center">
                  <v-rating
                    :value="item.playerData ? item.playerData.topStar : 0"
                    background-color="amber"
                    color="amber"
                    length="3"
                    readonly
                    dense
                    size="20"
                  ></v-rating>
                </v-col>

                <!-- Last Updated -->
                <v-col cols="2" md="2" class="text-right">
                  <div class="text-caption text--secondary">{{ $t("model.prop.lastUpdated") }}</div>
                  <div class="text-body-2">
                    <span
                      v-if="item.playerData && item.playerData.timestampUpdated"
                    >
                      {{
                        $moment(item.playerData.timestampUpdated).format(
                          "DD MMM YY"
                        )
                      }}
                    </span>
                    <span v-else class="text--disabled">-</span>
                  </div>
                  <div
                    class="text-caption text--secondary"
                    v-if="item.playerData && item.playerData.timestampUpdated"
                  >
                    {{
                      $moment(item.playerData.timestampUpdated).format("HH:mm")
                    }}
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </div>
      </div>
    </div>
    <div class="text-center mt-5" v-if="isLoading">
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>
  </v-container>
</template>

<script>
import DropdownChapter from "@/components/DropdownChapterV2";
import SchoolYear from "@/components/SchoolYear";

export default {
  components: {
    DropdownChapter,
    SchoolYear,
  },
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    isLoading: false,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },

    apiSchoolYear: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },

    apiTopic: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    syllabus: null,
    chapter: null,
    questions: null,
    years: [],
    selectedYear: null,
    mochiId: null,
    topics: [],
    playerData: null,
    yearRecord: [],
  }),
  created() {
    //BOC:[breadcrumbs]
    this.breadcrumbs.push({
      text: this.$t("route.PageMainHome"),
      to: { name: "PageMainHome" },
      exact: true,
    });
    this.breadcrumbs.push({
      text: this.$t("route.PageMainDiscover"),
      to: { name: "PageMainDiscover" },
      exact: true,
    });
    //EOC
  },
  mounted() {
    this.mochiId = this.$route.params.mochiId;
  },
  methods: {
    async loadPlayerData() {
      this.api.method = "post";
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/main/math/visit";

      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.playerData = resp.Player;
        this.yearRecord = resp.Record;
        this.fetchTopics();
      };
      this.api.params = {
        schoolYear: this.selectedYear,
        mochiId: this.mochiId,
      };
      await this.$api.fetch(this.api);
    },
    showError(error) {
      this.api.isError = true;
      this.api.error = error;
    },
    selectSyllabus(item) {
      console.log("selectSyllabus", item);
      this.syllabus = item;
      this.selectedYear = item.value;
      var that = this;
      setTimeout(() => {
        that.$refs["dropdown_chapter"].fetch();
      }, 100);
    },
    selectChapter(item) {
      this.chapter = item;
      //var that = this;
      // setTimeout(() => {
      //   that.$refs["grid_question"].fetch();
      // }, 100);
       this.isLoading = true;
      this.loadPlayerData();

      window.history.pushState(
        "",
        "",
        "?y=" + this.selectedYear + "&c=" + this.chapter.key
      );
    },
    async fetchTopics() {
      this.apiTopic.method = "get";
      this.apiTopic.url =
        this.$api.servers.question +
        "/v2/syllabi/" +
        this.syllabus.key +
        "/questions" +
        "?lang=" +
        this.$_getLocale();

      this.apiTopic.callbackReset = () => {
        this.apiTopic.isLoading = true;
        this.apiTopic.isError = false;
        this.apiTopic.error = null;
      };
      this.apiTopic.callbackError = (e) => {
        this.apiTopic.isLoading = false;
        this.apiTopic.isError = true;
        this.apiTopic.error = e;
      };
      this.apiTopic.callbackSuccess = (resp) => {
        this.apiTopic.isLoading = false;
        this.topics = resp.filter((element) =>
          element.key.includes(this.chapter.key)
        );

        this.topics.forEach((element) => {
          let xtopic = this.yearRecord.find(
            (elementx) => elementx.questionKey == element.key
          );
          if (xtopic) {
            element.playerData = xtopic;
          }
        });
        
      this.isLoading = false;
      };
      this.apiTopic.params = {
        lang: this.$_getLocale(),
      };
      await this.$api.fetch(this.apiTopic);
    },
  },
};
</script>